// extracted by mini-css-extract-plugin
module.exports = {"container":"e_sv","label":"e_tv","icon":"e_uv"};